import { getPageNoFromUrlHash } from '../utils';

export const dataCheck = (data) => {
  const checkD =
    data && data.data && data.data.data && data.data.data.length ? true : false;
  const curruntPageNo = getPageNoFromUrlHash();

  if (curruntPageNo > 1 && !checkD) return false;

  return true;
};

export const getPrev = (data) => {
  const { prev } =
    data && data.data && data.data.paging ? data.data.paging : {};

  return prev;
};
